import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-centers-center-schedule',
  templateUrl: './centers-center-schedule.component.html',
  styleUrls: ['./centers-center-schedule.component.scss']
})
export class CentersCenterScheduleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
